import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../../src/component/admin/AdminLayout";
import { createRetreatType } from "../../services/retreatTypeService";
export default function CreateRetreatType() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    typeName: "",
  route: "",

    heroTitle: "",
    heroSubtitle: "",
    heroDescription: "",

    heroImage: "",
    highlightsImage: "",
    gainsImage: "",

    duration: "",
    level: "",

    brochureUrl: "",

    experienceHighlights: [""],
    gains: [""],
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    
  };

  const handleHighlightChange = (
    index,
    value
  ) => {
    const updated = [
      ...formData.experienceHighlights,
    ];

    updated[index] = value;

    setFormData({
      ...formData,
      experienceHighlights: updated,
    });
  };

  const handleGainChange = (
    index,
    value
  ) => {
    const updated = [...formData.gains];

    updated[index] = value;

    setFormData({
      ...formData,
      gains: updated,
    });
  };

  const addHighlight = () => {
    setFormData({
      ...formData,
      experienceHighlights: [
        ...formData.experienceHighlights,
        "",
      ],
    });
  };

  const addGain = () => {
    setFormData({
      ...formData,
      gains: [...formData.gains, ""],
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const cleanTypeName = formData.typeName.trim();

  const payload = {
    ...formData,

    typeName: cleanTypeName,

    route: cleanTypeName
      .toLowerCase()
      .replace(/\s+/g, "-"),

    experienceHighlights: formData.experienceHighlights.filter(
      (item) => item.trim() !== ""
    ),

    gains: formData.gains.filter(
      (item) => item.trim() !== ""
    ),
  };

  try {
    const res = await createRetreatType(payload);

    if (res.status === 200 || res.status === 201) {
      alert("Retreat Type Created Successfully");
      navigate("/admin/retreat-types");
    }
  } catch (err) {
    console.error(err.response?.data || err);
    alert(
      err.response?.data?.message ||
      "Failed to create retreat type"
    );
  }
};

  return (
    <AdminLayout>
      <h1 className="text-4xl font-bold mb-8">
        Add Retreat Type
      </h1>

      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-2xl shadow space-y-5"
      >
        <input
          name="typeName"
          placeholder="innergise"
          value={formData.typeName}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="heroTitle"
          placeholder="Hero Title"
          value={formData.heroTitle}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="heroSubtitle"
          placeholder="Hero Subtitle"
          value={formData.heroSubtitle}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <textarea
          name="heroDescription"
          placeholder="Hero Description"
          value={formData.heroDescription}
          onChange={handleChange}
          className="w-full border p-3 rounded"
          rows={4}
        />

        <input
          name="heroImage"
          placeholder="Hero Image URL"
          value={formData.heroImage}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="highlightsImage"
          placeholder="Highlights Image URL"
          value={formData.highlightsImage}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="gainsImage"
          placeholder="Gains Image URL"
          value={formData.gainsImage}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="duration"
          placeholder="4 Days"
          value={formData.duration}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="level"
          placeholder="Beginner"
          value={formData.level}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <input
          name="brochureUrl"
          placeholder="Brochure URL"
          value={formData.brochureUrl}
          onChange={handleChange}
          className="w-full border p-3 rounded"
        />

        <div className="border p-4 rounded">
          <h3 className="font-bold mb-3">
            Experience Highlights
          </h3>

          {formData.experienceHighlights.map(
            (item, index) => (
              <input
                key={index}
                value={item}
                onChange={(e) =>
                  handleHighlightChange(
                    index,
                    e.target.value
                  )
                }
                className="w-full border p-3 rounded mb-2"
                placeholder="Highlight"
              />
            )
          )}

          <button
            type="button"
            onClick={addHighlight}
            className="bg-gray-200 px-4 py-2 rounded"
          >
            + Add Highlight
          </button>
        </div>

        <div className="border p-4 rounded">
          <h3 className="font-bold mb-3">
            What You'll Gain
          </h3>

          {formData.gains.map(
            (item, index) => (
              <input
                key={index}
                value={item}
                onChange={(e) =>
                  handleGainChange(
                    index,
                    e.target.value
                  )
                }
                className="w-full border p-3 rounded mb-2"
                placeholder="Gain"
              />
            )
          )}

          <button
            type="button"
            onClick={addGain}
            className="bg-gray-200 px-4 py-2 rounded"
          >
            + Add Gain
          </button>
        </div>

        <button
          type="submit"
          className="bg-secondary text-white px-6 py-3 rounded-xl"
        >
          Save Retreat Type
        </button>
      </form>
    </AdminLayout>
  );
}